import { useEffect } from "react";
import "./Login.less";
import { setToken, refershToken } from "./api";
import { store } from "./Store";
import { message } from "./message";

const win = global as any;
const loginUrl = process.env.LOGIN_PATH;

async function loadToken() {
  // 如果url的query里有token,直接登录
  if (win.location.search.includes("token=")) {
    const params = new URLSearchParams(win.location.search);
    const token = params.get("token");
    if (token) {
      setToken(token);
      await store.login(token);
      params.delete("token");
      // 然后重置url去掉token
      const othpath = params.toString() + win.location.hash;
      win.history.replaceState(
        null,
        null,
        win.location.pathname + (othpath ? "?" + othpath : "")
      );
    }
  }
}

async function checkRefershToken() {
  try {
    // 检查user的token是否要过期，过期前7天刷新token
    const user = await store.getUser();
    if (!user) {
      return false;
    }
    if (new Date().getTime() > user.expiredAt.getTime()) {
      return false;
    }
    if (
      new Date().getTime() >
      user.expiredAt.getTime() - 7 * 24 * 60 * 60 * 1000
    ) {
      const newToken = await refershToken(user.token);
      if (newToken) {
        await store.login(newToken.token);
        setToken(newToken.token);
      }
    } else {
      setToken(user.token);
    }
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
}

let sent = false;
export function Login(props: {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}) {
  useEffect(() => {
    loadToken()
      .then(checkRefershToken)
      .then((logined) => (logined ? store.loadUserExams() : null))
      .catch((err) => {
        message.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (props.visible) {
      win.history.pushState(null, null, win.location.href);
      win.addEventListener("popstate", () => props.setVisible(false));
      return () => {
        win.removeEventListener("popstate", () => props.setVisible(false));
      };
    } else {
      sent = false;
    }
  }, [props]);

  useEffect(() => {
    if (!props.visible) return;
    sent = false;
    const handle = async (event: any) => {
      if (
        event.origin === loginUrl && //确认消息来自于自己的域名 Make sure the message posted from your own origin
        !event.data.source && //过滤掉一些调试组件发来的信息  Filter out some devtools message
        !sent //避免多次运行回调函数  Avoid callback twice
      ) {
        const res = event.data;
        if (typeof res !== "string") {
          return;
        }
        sent = true;
        if (res === "disabled" || !res) {
          message.error("账户已禁用");
          props.setVisible(false);
        } else if (res === "close") {
          props.setVisible(false);
        } else if (res.startsWith("redirect:")) {
          win.location.href = res.substring(9);
        } else {
          try {
            setToken(res);
            await store.login(res);
            props.setVisible(false);
          } catch (err) {
            setToken("");
            message.error((err as any).message);
          }
        }
      }
    };
    win.addEventListener("message", handle);
    return () => {
      win.removeEventListener("message", handle);
    };
  }, [props]);

  return props.visible ? (
    <iframe
      className="code-login"
      frameBorder={0}
      title="登录"
      src={
        loginUrl +
        "?from=" +
        (process.env.NODE_ENV === "development" ? "local3330" : "ep") +
        "&dialog=true&type=pwd&plus=" +
        !!win.plus
      }
    ></iframe>
  ) : null;
}
